var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityEngineeringServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 74,
    viewBox: "0 0 73 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.251465,
    y: 0.64624,
    width: 72.5033,
    height: 72.5033,
    rx: 10.3576,
    fill: "#1F6256"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2714 38.1922V47.2551H26.1456V29.1292H32.645C32.7097 28.21 32.9298 27.3426 33.2664 26.5398H26.1456C24.7214 26.5398 23.5562 27.7051 23.5562 29.1292V47.2551C23.5562 48.6792 24.7214 49.8445 26.1456 49.8445H44.2714C45.6956 49.8445 46.8608 48.6792 46.8608 47.2551V40.7816L44.2714 38.1922ZM45.9545 32.8709C46.5242 31.9646 46.8608 30.9159 46.8608 29.7766C46.8608 26.5528 44.2584 23.9504 41.0346 23.9504C37.8108 23.9504 35.2085 26.5528 35.2085 29.7766C35.2085 33.0004 37.8108 35.6028 41.0217 35.6028C42.161 35.6028 43.2227 35.2661 44.116 34.6965L48.1555 38.7359L49.994 36.8975L45.9545 32.8709ZM41.0346 33.0134C39.2479 33.0134 37.7979 31.5633 37.7979 29.7766C37.7979 27.9899 39.2479 26.5398 41.0346 26.5398C42.8213 26.5398 44.2714 27.9899 44.2714 29.7766C44.2714 31.5633 42.8213 33.0134 41.0346 33.0134Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityEngineeringServiceIcon);
export default __webpack_public_path__ + "static/media/SecurityEngineeringServiceIcon.495b42d79372a865e474d5b392895c34.svg";
export { ForwardRef as ReactComponent };